import { useForm, UseFormProps } from 'react-hook-form';

import {
  CreateBookingPlannerRfpRequestDataAttributesAccountTypeEnum as AccountTypeEnum,
  CreateBookingPlannerRfpRequestDataAttributesSegmentationTypeEnum as SegmentationTypeEnum,
} from '@spazious/react-booking-engine';

export type ReservationFormValues = {
  proposalName: string;
  email: string;
  phoneNumber: string;
  startDate: Date;
  endDate: Date | null;
  segmentationType: SegmentationTypeEnum;
  attendees: number;
  accountType: AccountTypeEnum;
  accountName: string;
  description: string;
};

const initialvalues: Partial<ReservationFormValues> = {
  proposalName: '',
  email: '',
  phoneNumber: '',
  startDate: new Date(),
  endDate: null,
  segmentationType: undefined,
  attendees: 1,
  accountType: undefined,
  accountName: '',
  description: '',
};

export const useReservationForm = (props?: UseFormProps<ReservationFormValues>) => {
  const { defaultValues = initialvalues, mode = 'onChange', ...restProps } = { ...props };
  return useForm<ReservationFormValues>({ defaultValues, mode, ...restProps });
};
